import { render, staticRenderFns } from "./inpatientAdvancedView.vue?vue&type=template&id=9fa27bb2&scoped=true&"
import script from "./inpatientAdvancedView.vue?vue&type=script&lang=js&"
export * from "./inpatientAdvancedView.vue?vue&type=script&lang=js&"
import style0 from "./inpatientAdvancedView.vue?vue&type=style&index=0&id=9fa27bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa27bb2",
  null
  
)

export default component.exports